let redirectHandler = null;

/** App 启动时注入 router.replace({ name: 'Home' }) */
export function setUnauthenticatedRedirect(handler) {
  redirectHandler = typeof handler === 'function' ? handler : null;
}

export function redirectUnauthenticatedToHome() {
  if (redirectHandler) {
    redirectHandler();
    return;
  }
  if (typeof window !== 'undefined') {
    const path = window.location.pathname.replace(/\/+$/, '') || '/';
    if (path !== '/' && path !== '') {
      window.location.replace('/');
    }
  }
}
